import { request } from 'app/utils';
import { Loading } from 'components';
import { useContents } from 'features/contents';
import { useSchool } from 'features/school';
import { SurveyForm } from 'features/surveys';
import { useCallback } from 'react';
import { useParams } from 'react-router-dom';

const ContentSurveyView = () => {
  const { productClassUuid, contentUuid } = useParams();

  const { contentDetails } = useContents();

  const { apiGatewayUrl } = useSchool();

  const onComplete = useCallback(
    async (formData: string) => {
      await new Promise(async (resolve, reject) => {
        await request({
          url: `/api/v1/School/AssessContentSurveyResponse`,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json;charset=UTF-8',
          },
          baseURL: apiGatewayUrl,
          data: {
            productClassUuid,
            contentUuid,
            formData,
          },
        })
          .then(resolve)
          .catch(reject);
      });
    },
    [contentDetails]
  );

  if (!contentDetails?.survey) return <Loading />;

  return (
    <>
      <SurveyForm formData={`${contentDetails?.survey?.formData}`} onComplete={onComplete} />
    </>
  );
};

export default ContentSurveyView;
